import React, { useEffect, useState } from 'react';
import { Header } from '@tcs/client-portal-common/components/organisms/Header';
import useSession from '@tcs/client-portal-common/hooks/useSession';
import useFeesLink from '@tcs/client-portal-common/hooks/useFeesLink';
import { Spinner, ToastUtils } from '@forgeglobal/design-framework';

// When the client clicks the fees banner or link on the nav panel
// retrieve the link and redirect to payment site
export const FeesRedirect = () => {
  const {
    claims: { clientPortalIdentity },
  } = useSession();
  const { loading, data } = useFeesLink(clientPortalIdentity);
  const [message, setMessage] = useState(
    'Redirecting to the payment portal...'
  );

  useEffect(() => {
    if (!loading && data && data.URL) {
      setMessage('Redirecting to the payment portal...');
      window.location.href = data.URL;
    } else if (!loading && data && data.statusCode !== '200') {
      ToastUtils.error(
        'Failed to connect to payment portal. Please try the link again.',
        true
      );
    }
  }, [loading, data]);

  return (
    <>
      <Header pageTitle={message} />
      <Spinner />
    </>
  );
};

export default FeesRedirect;
